import React from "react";
import { useTranslation } from "react-i18next";
import AuthPage from "./AuthPage.jsx";

export default function MFASelectionForm({ handleSelectMFAType }) {
  const { t } = useTranslation();

  return (
    <AuthPage title={t("mfaTitle")} subtitle={t("mfaSubtitle")}>
      <div className="space-y-3">
        <button
          type="button"
          onClick={() => handleSelectMFAType("SMS")}
          className="w-full rounded-lg bg-sky-600 px-4 py-3 font-semibold text-white transition hover:bg-sky-700"
        >
          SMS
        </button>
        <button
          type="button"
          onClick={() => handleSelectMFAType("TOTP")}
          className="w-full rounded-lg border border-sky-600 px-4 py-3 font-semibold text-sky-700 transition hover:bg-sky-50"
        >
          {t("authenticatorApp")}
        </button>
      </div>
    </AuthPage>
  );
}
